import React from 'react';
import { Tooltip } from '@material-ui/core';

export const PointsSwitch = ({ label, action, name, included, disabled, tooltip }) => {
  return (
    <div>
      <div className="col 12 m7 s7"><label>{label}</label></div>
      <div className="col 12 m5 s5">
          <Tooltip 
            title={<span className="tooltip-text" >{tooltip}</span>} 
            disableHoverListener={!disabled} >
            <div className="radio-group-2 aggregate-radio">
              <input 
                type="radio" 
                id={`${name}-yes`} 
                name={name} 
                value="yes" 
                disabled={disabled}
                checked={included === true}
                onChange={() => action(true)} />
              <label htmlFor={`${name}-yes`}>Yes</label>

              <input 
                type="radio" 
                id={`${name}-no`} 
                name={name} 
                value="no" 
                disabled={disabled}
                checked={included === false }
                onChange={() => action(false)} />
              <label htmlFor={`${name}-no`}>No</label> 
            </div>
          </Tooltip>
      </div>
    </div>
  );
};
